// extracted by mini-css-extract-plugin
export default {"page":"loginPrompt_page__5rsok"};